<textarea (ngModelChange)="textAreaChanged($event)" matInput
          [(ngModel)]="acModel"
          [disabled]="(ngDisabled || (acInputContainerComponent && acInputContainerComponent.isDisabled))?true:null"
          [attr.maxlength]="maxLength?maxLength:null"
          [attr.placeholder]="placeHolderText?placeHolderText:null"
          [attr.rows]="visibleRows?visibleRows:1"
          [id]="textAreaId"
          class="ac-textarea">
</textarea>
